import React from 'react';
import KickImage from 'Reuseables/KickImage';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Container
} from 'reactstrap';
import { convertToRupiah, getCloudImageUrl } from '../../../utils';
import moment from 'moment';
import { ASSET_IMAGE } from '../../../config';
import { Link } from 'react-router-dom';
import ModalSnapPay from './ModalSnapPay';
import CloseIcon from '../../../images/close-button-search.png';
import { IconContext } from 'react-icons';
import { GrClose } from 'react-icons/gr';

const PaymentConfirmLink = ({ id, invoiceNumber, url, paymentMethod, onRedirectXendit, history, total_amount }) => (
  id ?
    (
      paymentMethod === 'virtual_account' ?
        <Button className="btn-green" onClick={() => onRedirectXendit(url)}>Payment Confirmation</Button>
        :
        <Button className="btn-green" onClick={() => paymentConfirmationBank(history, total_amount, invoiceNumber)}>Payment Confirmation</Button>
    )
    : null
)

const paymentConfirmationBank = (history, total_amount, invoiceNumber) => {
  const pathname = `/payment_confirmation/${invoiceNumber}`;
  history.push({ pathname, search: `?transfer_amount=${parseInt(total_amount)}` })
}

const BankAccountContainer = ({ accountNumber, accountName, bankName }) => (
  <div className="bank-content">
    <div className="bank-icon">
      <KickImage className="img-responsive" src={`${ASSET_IMAGE}/email/${bankName.toLowerCase()}.png`} alt={bankName} />
    </div>
    <div className="text-desc2 third-modal">
      <p>{accountNumber}</p>
      <p>{accountName}</p>
    </div>
  </div>
)

class ModalWalletLog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _modalSnapIsOpen: false
    }
  }
  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.setState({
        _modalSnapIsOpen: false
      })
    }
  }

  _handleOnToggleModalSnap = async () => {
    await this.setState({ _modalSnapIsOpen: !this.state._modalSnapIsOpen })
    const { _modalSnapIsOpen } = this.state;
    if (!_modalSnapIsOpen && this.props.onToggle) this.props.onToggle();
  }

  render() {
    const totalReceived = Number(this.props.total_amount) - Number(this.props.fee)
    const uniqueNumber = this.props.disbursementNumber ? this.props.disbursementNumber : this.props.invoiceNumber;
    return (
      <div>
        <ModalSnapPay
          isCloseable
          isOpen={this.state._modalSnapIsOpen}
          invoiceNumber={this.props.invoiceNumber}
          headerTitle={this.props.invoiceNumber}
          redirectUrl={this.props.invoiceUrl}
          onToggle={this._handleOnToggleModalSnap}
        />
        <Modal
          className="kick-modal wallet-log"
          isOpen={this.props.isOpen}
          toggle={this.props.onToggle}
          centered
        >
          {
            this.props.isOpen ?
              <Container id="wallet-log">
                <ModalHeader id="header-wallet-log">
                  <div className="balance-icon">
                    <KickImage src={getCloudImageUrl(this.props.icon, 400)} />
                  </div>
                  <div className="wallet-title">
                    <p className="title">{this.props.title}</p>
                    <p className="value">{uniqueNumber}</p>
                  </div>
                </ModalHeader>
                {
                  this.props.type !== 'TOPUP' ?
                    <ModalBody className="wallet-detail-section">
                      <div className="wallet-detail-container">
                        <p className="title">Transaction Date</p>
                        <p className="value">{moment(this.props.created_at).format("DD MMMM YYYY")}</p>
                      </div>
                      <div className="wallet-detail-container">
                        <p className="title">Amount</p>
                        <p className="value">IDR {convertToRupiah(parseInt(this.props.total_amount, 10))}</p>
                      </div>
                      <div className="wallet-detail-container">
                        <p className="title">Cash Out Fee</p>
                        <p className="value">IDR {convertToRupiah(parseInt(this.props.fee, 10))}</p>
                      </div>
                      <div className="wallet-detail-container">
                        <p className="title">Total Amount Received</p>
                        <p className="value">IDR {convertToRupiah(parseInt(totalReceived, 10))}</p>
                      </div>
                      <div className="wallet-detail-container">
                        <p className="title">Transaction Type</p>
                        <p className="value">{this.props.type.replace(/[_]/g, ' ').toUpperCase()}</p>
                      </div>
                      <div className="wallet-detail-container">
                        <p className="title">Account Number</p>
                        <p className="value">{this.props.dataBank && this.props.dataBank.account_number_recipient ? this.props.dataBank.account_number_recipient : "-"}</p>
                      </div>
                      <div className="wallet-detail-container">
                        <p className="title">Account Holder's Name</p>
                        <p className="value">{this.props.dataBank && this.props.dataBank.account_name_recipient ? this.props.dataBank.account_name_recipient : "-"} </p>
                      </div>
                      <div className="wallet-detail-container">
                        <p className="title">Bank Name</p>
                        <p className="value">{this.props.dataBank && this.props.dataBank.bank_name_recipient ? this.props.dataBank.bank_name_recipient : "-"} </p>
                      </div>
                      <div className="wallet-detail-container">
                        <p className="title">Note</p>
                        <p className="value">{!this.props.note ? '__' : this.props.note}</p>
                      </div>
                      {
                        this.props.status?.replace(/[_]/g, ' ')?.toUpperCase() === "UNVERIFIED" ?
                          <div className="wallet-detail-container">
                            <p className="title">Unverified Cashout</p>
                            <p style=
                              {{
                                color: "#e02020",
                                fontStyle: "italic"
                              }}
                              className="value"
                            >Please click the link inside the email we just sent you to approve or reject this cash out request. You must click the link within 5 minutes or you will have to create a new request. It can take up to 24 hours for the funds to enter your account. You can contact us on WhatsApp at +6281210005425 should you have any inquiries.
                            </p>
                          </div>
                          : null
                      }

                    </ModalBody>
                    :
                    <ModalBody className="wallet-detail-section">
                      <div className="wallet-detail-container">
                        <p className="title">Transaction Date</p>
                        <p className="value">{moment(this.props.created_at).format("DD MMMM YYYY")}</p>
                      </div>
                      <div className="wallet-detail-container">
                        <p className="title">Amount</p>
                        <p className="value">IDR {convertToRupiah(parseInt(this.props.total_amount, 10))}</p>
                      </div>
                      {
                        this.props.paymentMethod ?
                          <div className="wallet-detail-container">
                            <p className="title">Payment Method</p>
                            <p className="value">{this.props.paymentMethod.replace(/[_]/g, ' ').toUpperCase()}</p>
                          </div>
                          :
                          null
                      }
                    </ModalBody>
                }
                {
                  this.props.expiredPayment && this.props.type === "TOPUP" ? null
                    :
                    (
                      this.props.type === "TOPUP" ?
                        <div className="wrap-button-text">
                          {
                            this.props.paymentVia === 'vt' ?
                              <Button className="btn-green" onClick={() => this.setState({ _modalSnapIsOpen: true })}>
                                Payment Confirmation
                              </Button>
                              :
                              <PaymentConfirmLink
                                id={this.props.id}
                                invoiceNumber={this.props.invoiceNumber}
                                total_amount={this.props.total_amount}
                                url={this.props.invoiceUrl}
                                paymentMethod={this.props.paymentMethod}
                                onRedirectXendit={url => window.location = url}
                                history={this.props.history}
                              />
                          }
                        </div>
                        : null
                    )
                }
              </Container>
              : null
          }
          <div className={'close-button'} onClick={this.props.onToggle}>
            <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
              <div>
                <GrClose />
              </div>
            </IconContext.Provider>
          </div>
        </Modal>
      </div >
    )
  }
}

export default ModalWalletLog;
